export enum IEVENT_NAMES {
  INVOICE_CREATION_STARTED = 'INVOICE_CREATION_STARTED',
  INVOICE_STATUS_CHANGED = 'INVOICE_STATUS_CHANGED',
  PAYMENT_METHOD_SELECTED = 'PAYMENT_METHOD_SELECTED',
  PAYMENT_COMPLETED = 'PAYMENT_COMPLETED',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  BILLING_INFO_UPDATED = 'BILLING_INFO_UPDATED',
  LINE_ITEM_ADDED = 'LINE_ITEM_ADDED',
  LINE_ITEM_REMOVED = 'LINE_ITEM_REMOVED',
  DISCOUNT_APPLIED = 'DISCOUNT_APPLIED',
  PATIENT_BALANCE_VIEWED = 'PATIENT_BALANCE_VIEWED',
  LIST_INVOICE_ACTION_CLICKED = 'LIST_INVOICE_ACTION_CLICKED',
  LIST_INVOICE_CREATE_INITIATED = 'LIST_INVOICE_CREATE_INITIATED',
  LIST_INVOICE_EXPORT_CLICKED = 'LIST_INVOICE_EXPORT_CLICKED',
  LIST_PATIENT_ACTION_CLICKED = 'LIST_PATIENT_ACTION_CLICKED',
  LIST_FILTER_APPLIED = 'LIST_FILTER_APPLIED',
  LIST_SORT_CHANGED = 'LIST_SORT_CHANGED',
  LIST_PAGE_SIZE_CHANGED = 'LIST_PAGE_SIZE_CHANGED',
  LIST_SEARCH_PERFORMED = 'LIST_SEARCH_PERFORMED',
  LIST_ITEM_SELECTED = 'LIST_ITEM_SELECTED',
  LIST_NOTES_ACTION_CLICKED = 'LIST_NOTES_ACTION_CLICKED',
  LIST_TERMINAL_PAYMENT_INITIATED = 'LIST_TERMINAL_PAYMENT_INITIATED',
  PAYMENT_REMINDER_SENT = 'PAYMENT_REMINDER_SENT',
  SEND_INVOICE_LINK = 'SEND_INVOICE_LINK',
  INVOICE_CREATED = 'INVOICE_CREATED',
}
